import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { HistoricoManutencao } from '../../types/manutencao';
import {
  historicoManutencaoService,
  ListParams,
  manutencaoMaquinasService,
} from '../../services';

const columns: ResourceColumn<HistoricoManutencao>[] = [
  { header: "Ordem", accessor: "ordem_info" },
  { header: "Máquina", accessor: "maquina_nome" },
  { header: "Evento", accessor: "tipo_evento" },
  { header: "Data", accessor: "data_evento" },
  { header: "Responsável", accessor: "operador_responsavel" }
];

export const HistoricoManutencaoListPage: React.FC = () => {
  const navigate = useNavigate();
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');
  const [maquina, setMaquina] = useState('');
  const [maquinas, setMaquinas] = useState<Array<{ id: number; nome: string }>>([]);
  const [loadingMaquinas, setLoadingMaquinas] = useState(false);

  useEffect(() => {
    const loadMaquinas = async () => {
      setLoadingMaquinas(true);
      try {
        const response = await manutencaoMaquinasService.list({ page: 1, page_size: 100 });
        setMaquinas(response.results);
      } catch (err) {
        console.error('Erro ao carregar máquinas:', err);
      } finally {
        setLoadingMaquinas(false);
      }
    };
    loadMaquinas();
  }, []);

  const list = useCallback(
    (params?: ListParams) =>
      historicoManutencaoService.list({
        ...params,
        ordem__finalizado: true,
        data_evento__gte: dataInicio || undefined,
        data_evento__lte: dataFim || undefined,
        maquina: maquina || undefined,
      }),
    [dataFim, dataInicio, maquina],
  );
  const filteredService = useMemo(
    () => ({ ...historicoManutencaoService, list }),
    [list],
  );

  return (
    <>
      <Form className="d-flex flex-wrap gap-3 mb-3">
        <Form.Group>
          <Form.Label>Data de início</Form.Label>
          <Form.Control
            type="date"
            value={dataInicio}
            onChange={(event) => setDataInicio(event.target.value)}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Data de fim</Form.Label>
          <Form.Control
            type="date"
            value={dataFim}
            onChange={(event) => setDataFim(event.target.value)}
          />
        </Form.Group>
        <Form.Group className="flex-grow-1" style={{ minWidth: '240px' }}>
          <Form.Label>Máquina</Form.Label>
          <Form.Select
            value={maquina}
            onChange={(event) => setMaquina(event.target.value)}
            disabled={loadingMaquinas}
          >
            <option value="">{loadingMaquinas ? 'Carregando...' : 'Todos'}</option>
            {maquinas.map((item) => (
              <option key={item.id} value={String(item.id)}>
                {item.nome}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Form>
      <ResourceListPage
        title="Histórico de manutenção"
        description="Eventos registrados em cada ordem."
        columns={columns}
        service={filteredService}
        createPath="/admin/manutencao/historico-manutencao/novo"
        onEdit={(item) =>
          item.id &&
          navigate('/admin/manutencao/historico-manutencao/editar', { state: { record: item } })
        }
      />
    </>
  );
};
